export let version = '0.0.112'; // generated source, do not edit
